// extracted by css-extract-rspack-plugin
export default {"cls1":"SimplePaperPodcast-cls1_nCJ","cls2":"SimplePaperPodcast-cls2_SuG SimplePaperPodcast-cls1_nCJ"};